import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTheme } from "../../theme/ThemeProvider";
import Layout from "../../components/Layout";
import { useSEO } from "../../hooks/useSEO";
import { SELL_ONLINE_ROUTE, CATEGORY_ROUTE } from "../../routes/constant";
import {
  FiChevronRight,
  FiSmartphone,
  FiTablet,
  FiWatch,
} from "react-icons/fi";
import RectangleGridButtons from "../../components/home/nav/NavButton";
import SearchModal from "../../components/common/search/SearchModal";

const SellOnline = () => {
  const { isDarkMode } = useTheme();

  useSEO(SELL_ONLINE_ROUTE);

  const { categories } = useSelector((state) => state.home);

  const getCategoryIcon = (category) => {
    if (category.name?.toLowerCase().includes("phone"))
      return <FiSmartphone size={20} />;
    if (category.name?.toLowerCase().includes("tablet"))
      return <FiTablet size={20} />;
    if (category.name?.toLowerCase().includes("watch"))
      return <FiWatch size={20} />;
    return <FiSmartphone size={20} />;
  };

  const getPlaceholderTexts = () => {
    if (!categories || categories.length === 0) {
      return [
        "Search for Mobile Phones...",
        "Search for Tablets...",
        "Search for Smart Watches...",
      ];
    }

    return categories.map(
      (cat) => `Search for ${cat.display_name || cat.name}...`,
    );
  };

  const placeholderTexts = getPlaceholderTexts();

  return (
    <Layout>
      <div className="mx-auto overflow-x-hidden max-w-7xl">
        <RectangleGridButtons isDarkMode={isDarkMode} />
      </div>
      <div className={`${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
        <div className="px-4 py-6 mx-auto max-w-7xl md:py-8">
          
          {/* Header with heading and search bar inline */}
          <div className="flex flex-col gap-4 mb-6 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1
                className={`text-xl md:text-2xl font-bold ${isDarkMode ? "text-white" : "text-gray-800"}`}
              >
                Sell Your Device
              </h1>
              <p
                className={`text-xs mt-1 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
              >
                Choose category to get best price
              </p>
            </div>

            {/* Search Bar - Right side on desktop */}
            <div className="lg:min-w-[320px]">
              <SearchModal
                isDesktop={true}
                isDarkMode={isDarkMode}
                placeholderTexts={placeholderTexts}
              />
            </div>
          </div>
          {categories && categories.length > 0 ? (
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 md:gap-3">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={CATEGORY_ROUTE(category.slug)}
                  className={`block overflow-hidden rounded-lg ${
                    isDarkMode
                      ? "bg-gray-800 hover:bg-gray-700"
                      : "bg-white border border-gray-200"
                  }`}
                >
                  <div className="p-3 md:p-4">
                    {category.image ? (
                      <img
                        src={category.image}
                        alt={category.name}
                        className="object-contain w-full h-20 rounded-lg md:h-24"
                      />
                    ) : (
                      <div
                        className={`w-full h-20 md:h-24 flex items-center justify-center rounded-lg ${isDarkMode ? "bg-gray-700 text-green-400" : "bg-gray-100 text-green-500"}`}
                      >
                        {getCategoryIcon(category)}
                      </div>
                    )}
                  </div>
                  <div className="px-3 pt-0 pb-3 md:px-4 md:pb-4">
                    <h3
                      className={`text-xs md:text-sm font-medium truncate text-center ${isDarkMode ? "text-white" : "text-gray-800"}`}
                    >
                      {category.display_name || category.name || ""}
                    </h3>
                    <div className="flex items-center justify-center mt-1">
                      <p
                        className={`text-[10px] md:text-xs ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
                      >
                        Sell Now
                      </p>
                      <FiChevronRight
                        size={10}
                        className={`ml-1 ${isDarkMode ? "text-gray-600" : "text-gray-400"}`}
                      />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="py-8 text-center">
              <p
                className={`text-sm ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
              >
                No categories available
              </p>
            </div>
          )}

          {/* Footer Info */}
          <div
            className={`mt-6 pt-4 text-center text-[11px] md:text-xs border-t ${isDarkMode ? "border-gray-800 text-gray-500" : "border-gray-200 text-gray-400"}`}
          >
            <p>Get best price for your old device • Free doorstep pickup • Instant payment</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SellOnline;